import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { HttpService } from '@services/http.service';
import { EndpointParams } from '@models/utils/endpoint-params';
import { PaymentCreateResponse } from '@models/buy/response/payment-create-response';
import { Combo } from '@models/fee/combo/combo';
import { ComboBuy } from '@models/index';

@Injectable({
    providedIn: 'root'
})
export class RatesComboService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    private comboSubject = new BehaviorSubject<Combo[]>([]);
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { fees: Combo[] } = { fees: [] };

    readonly combos = this.comboSubject.asObservable();
    readonly loadingData = this.isLoadingDataSubject.asObservable();

    list(): void {
        this.loading(true);
        this.listFees().subscribe(
            () => {
                this.next();
                this.loading(false);
            }
        );
    }

    search(idCombo: string): Observable<any> {
        return this.get(`fee/combo/member/${idCombo}`, this.defaultEndpointParams);
    }

    private listFees(): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.get('fee/combo/member', this.defaultEndpointParams).subscribe(
                    data => {
                        this.dataStore.fees = [];
                        data.forEach((payment: any) => {
                            this.dataStore.fees.push(new Combo().build(payment));
                        });

                        this.dataStore.fees.sort((a, b) => a.order - b.order);
                        observable.next(true);
                    }, () => observable.next(false)
                );
            }
        );
    }

    private next(): void {
        this.comboSubject.next([ ...this.dataStore.fees ]);
    }

    private loading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }
}
